"use strict";
import * as React from "react";
const SvgWorkflow = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    height: 800,
    width: 800,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 394.953 394.953",
    xmlSpace: "preserve",
    ...props
  },
  /* @__PURE__ */ React.createElement("path", { d: "M394.953 325.334v-49.869a5.504 5.504 0 0 0-5.503-5.504h-44.375v-67.34a5.502 5.502 0 0 0-5.503-5.502H202.974v-55.496h61.002a5.502 5.502 0 0 0 5.503-5.502V69.619a5.504 5.504 0 0 0-5.503-5.504H130.974a5.504 5.504 0 0 0-5.503 5.504v66.502a5.502 5.502 0 0 0 5.503 5.502h60.994v55.496H55.373a5.502 5.502 0 0 0-5.503 5.502v67.34H5.503A5.504 5.504 0 0 0 0 275.465v49.869a5.504 5.504 0 0 0 5.503 5.504h99.747a5.504 5.504 0 0 0 5.503-5.504v-49.869a5.504 5.504 0 0 0-5.503-5.504H60.875v-61.836h131.092v61.836h-44.371a5.503 5.503 0 0 0-5.503 5.504v49.869a5.503 5.503 0 0 0 5.503 5.504h99.751a5.503 5.503 0 0 0 5.503-5.504v-49.869a5.503 5.503 0 0 0-5.503-5.504h-44.374v-61.836h131.096v61.836h-44.371a5.503 5.503 0 0 0-5.503 5.504v49.869a5.503 5.503 0 0 0 5.503 5.504h99.751a5.504 5.504 0 0 0 5.504-5.504zM136.477 130.617V75.121h121.996v55.496H136.477zm-36.729 150.35v38.865H11.006v-38.865H99.748zm142.097 0v38.865H153.1v-38.865h88.745zm142.102 38.865h-88.746v-38.865H383.947v38.865z" })
);
export default SvgWorkflow;
